module.exports = __webpack_public_path__ + "img/link_packages_icon.5398474a.png";